import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { selectVolume } from '../store/slice'

export const VolumeTitle = () => {
  const volume = useSelector(selectVolume)

  return (
    <Translate
      className="fw600"
      value={
        'userManagement.orderManagement.orderDetail.' +
        (volume?.isScreening ? 'NUMBER_OF_COMPANIES' : 'VOLUME')
      }
    />
  )
}
